import { Injectable } from '@angular/core';
import { LoginFormValidate } from '@com-delta-idp/mnx-login-ui';
import { ANALYTICS_EVENTS_LOGIN } from '../../constants/analytics-constants';
import { ERROR_CODES, VIEW_NAME } from '../../constants/login-constant';
import { SQAuthenticationScreen } from '../../models/recover-by-sqa.interface';
import { RecoverSqaFacadeSupportService } from './recover-sqa-facade-support.service';

@Injectable({
  providedIn: 'root'
})
export class RecoverSqaFacadeHelperService extends RecoverSqaFacadeSupportService {
  getSecurityContent(): SQAuthenticationScreen {
    return this.pageContent$.value || ({} as SQAuthenticationScreen);
  }

  handleErrorSecurityQuestions(code: string): void {
    if (code) {
      this.getSecurityContent().errorCode = code;
      const bffErrorMessage = this.loginHelperUtils.getErrorMessageFromAem(
        this.aemContent,
        `ERROR_MSG_${code}`
      );
      if (bffErrorMessage) {
        this.sqaError$.next(bffErrorMessage);
      } else {
        this.sqaError$.next(this.handleDefaultSQAError());
      }
    } else {
      this.sqaError$.next(this.handleDefaultSQAError());
    }
  }

  handleError(response: [{ code: string }]): void {
    if (response && response[0]?.code) {
      this.getSecurityContent().errorCode = response[0]?.code;
      const bffErrorMessage = this.loginHelperUtils.getErrorMessageFromAem(
        this.aemContent,
        `ERROR_MSG_${response[0]?.code}`,
        response[0]?.code
      );
      if (bffErrorMessage) {
        this.setFormAlertErrorMessage(bffErrorMessage);
        this.sqaError$.next(bffErrorMessage);
      } else {
        this.handleDefaultError();
      }
    } else {
      this.handleDefaultError();
    }
  }

  setFormAlertErrorMessage(message: string) {
    if (this.getSecurityContent()?.pageContent) {
      this.getSecurityContent().pageContent.errors.formAlertErrorMessage =
        message;
    }
  }

  handleDefaultError(): void {
    this.getSecurityContent().errorCode = ERROR_CODES.ERROR_CODE_21;
    const bffErrorMessage = this.loginHelperUtils.getErrorMessageFromAem(
      this.aemContent,
      `ERROR_MSG_${ERROR_CODES.ERROR_CODE_21}`
    );
    this.sqaError$.next(bffErrorMessage);
  }

  handleDefaultSQAError(): string {
    this.getSecurityContent().errorCode = ERROR_CODES.ERROR_CODE_21;
    const bffErrorMessage = this.loginHelperUtils.getErrorMessageFromAem(
      this.aemContent,
      `ERROR_MSG_${ERROR_CODES.ERROR_CODE_21}`
    );
    return bffErrorMessage;
  }

  handleSqaResponseErrors(response: [{ code: string }]) {
    if (response && response[0]?.code) {
      this.isSQALock(response);
    } else {
      this.handleDefaultError();
    }
  }

  setActionButtonDisable(value: boolean): void {
    this.getSecurityContent().disableButton = value;
  }

  resetRecoverSQAForm() {
    this.getSecurityContent().pageContent.errors.formAlertErrorMessage = '';
    this.getSecurityContent().errorCode = undefined;
    this.getSecurityContent().sqaFormAttributes = {
      answer1ControlTouched: false,
      answer2ControlTouched: false,
      errorAlertBanner: false,
      submitAttempt: false,
      errorCount: 0
    };
    this.getSecurityContent().formGroup?.reset();
    this.sqaError$.next('');
  }

  formValueChange(): void {
    this.getSecurityContent().formGroup.valueChanges.subscribe(() => {
      this.getSecurityContent().sqaFormAttributes.errorCount =
        LoginFormValidate.validateFormFields(
          this.getSecurityContent().formGroup
        );
      this.getSecurityContent().sqaFormAttributes.errorAlertBanner =
        LoginFormValidate.getErrorAlert(this.getSecurityContent().formGroup);
    });
  }

  focusChange(fieldName: string) {
    LoginFormValidate.touchControlSecurityscreen(
      fieldName,
      this.getSecurityContent()
    );
  }

  isSQALock(response: [{ code: string }]) {
    if (response[0]?.code === ERROR_CODES.ERROR_CODE_111) {
      this.resetRecoverSQAForm();
      if (this.wifiPortalService.getQueryParamsWFP().isWFP) {
        this.wifiPortalService.isSecurityQuestionLocked(true);
        this.wifiPortalService.getRefreshUrlWFP(true);
        return;
      }
      this.analytics.dispatchCustomEvent(
        ANALYTICS_EVENTS_LOGIN.RECOVERY_ACCOUNT_LOADED,
        true
      );
      this.nextDisplayViewService.nextDisplayView(
        VIEW_NAME.RECOVER_ACCOUNT_SCREEN
      );
    } else {
      this.handleError(response);
      this.getSecurityContent().sqaFormAttributes.answer1ControlTouched = true;
      this.getSecurityContent().sqaFormAttributes.answer2ControlTouched = true;
    }
  }
}
